export const countryCodes = ['RS', 'RU'] as const;

export const countries: CountryItem[] = [
    { code: 'RS', title: 'Serbia', slug: 'serbia' },
    {
        code: 'RU',
        title: 'Russia',
        slug: 'russia',
    },
];

export type CountryCode = (typeof countryCodes)[number];

export interface CountryItem {
    code: CountryCode;
    title: string;
    slug: string;
}

export const countryDefaultCode: CountryCode = 'RS';
